export default "__VITE_ASSET__DLABxDz1__"